// extracted by mini-css-extract-plugin
module.exports = {"campaignPageDraftsNavigation":"CampaignPageDrafts_campaignPageDraftsNavigation__YZWg1","campaignPageDraftsListEmpty":"CampaignPageDrafts_campaignPageDraftsListEmpty__ybZAE"};